import React from "react";
import { useTranslation } from "react-i18next";
import backgroubdSectionFour from "../../assets/images/backgroubdSectionFour.svg";
import FeatureCards from "../common/FeatureCards";
import Numbers from "../common/Numbers";
import ButtonGroup from "../categories/ButtonGroup";
import SectionHeader from "../common/SectionHeader";
import { SECTION_CONTAINER } from "../../utils/layout";

function SectionFourHomePage() {
  const { t } = useTranslation();

  return (
    <div
      className="caf-section caf-section--textured style-blend-mode-for-sectionFour min-h-0"
      style={{ backgroundImage: `url(${backgroubdSectionFour})` }}
    >
      <section
        className="caf-section__block caf-section__block--spaced"
        aria-labelledby="section-four-features-title"
      >
        <SectionHeader
          titleId="section-four-features-title"
          eyebrow={`${t("CAF")} ${t("SPORTS")}`}
          title={t("Expert & Professional")}
          subtitle={t("Always distinguished in all designs and products")}
        />
        <FeatureCards className="caf-section__cards" />
      </section>

      <section
        className="caf-section__block caf-section--elevated"
        aria-labelledby="section-four-gallery-title"
      >
        <SectionHeader
          titleId="section-four-gallery-title"
          eyebrow={t("Versatile Solutions")}
          title={t("Our Projects")}
          subtitle={t(
            "Discover Versatile Solutions Tailored to Meet Your Every Need",
          )}
        />
        <div className={`${SECTION_CONTAINER} pb-2`}>
          <ButtonGroup />
        </div>
      </section>

      <section className="caf-section__stats" aria-label="Company statistics">
        <Numbers />
      </section>
    </div>
  );
}

export default SectionFourHomePage;
